import { http } from '@/shared/api';

const api = '/ms/support/api/v1';

export const create = (payload: any) => http.post(`${api}/tickets`, payload, { headers: { 'Content-Type': 'multipart/form-data'} });